import { FlightState } from "@/lib/redux/features/flight/type"
import { isGalileoSystem } from "@/utils/flight/isGalileoSystem"

/**
 * Thứ tự ưu tiên HIỂN THỊ kết quả bay (số nhỏ = lên trên).
 * Trong mỗi tier, thứ tự vẫn theo sort đang chọn (mặc định giá thấp → cao).
 *  0. Chuyến "may mắn / sky"  – có card KM "liên hệ ngay" (promotionVJ)
 *  1. 9G
 *  2. VN (Vietnam Airlines), QH (Bamboo)
 *  3. VJ (Vietjet), VU (Vietravel)
 *  4. Các hãng còn lại (TR, JQ, BL, AK, ...)
 *  5. Vé Galileo / 1G – luôn nằm cuối cùng
 */
export const FLIGHT_SORT_TIER = {
  LUCKY_SKY: 0,
  NINE_G: 1,
  VN_QH: 2,
  VJ_VU: 3,
  OTHER: 4,
  GALILEO_1G: 5,
} as const

export const FLIGHT_SORT_TIER_COUNT = Object.keys(FLIGHT_SORT_TIER).length

// [CHỈ DEV] Gom thêm QH vào tier "may mắn/sky" để tiện test hiển thị trên server dev.
// staging/production giữ QH ở tier VN_QH như bình thường.
const IS_DEV = process.env.NEXT_PUBLIC_NODE_ENV === "dev"

// Hãng khai thác chính của chuyến (ưu tiên operatingAirline như FlightItem đang dùng).
const getMainAirline = (flight: any): string => {
  const seg = flight?.segments?.[0]
  if (!seg) return ""
  return String(seg.operatingAirline || seg.airline || "")
    .replace("_", "")
    .toUpperCase()
}

// Chuyến "may mắn": vé rẻ nhất có cờ khuyến mãi VJ → FlightItem render card "liên hệ ngay".
const hasLuckySkyPromo = (flight: any): boolean => {
  const cheapestInv = [...(flight?.inventories || [])].sort(
    (a, b) => (a?.totalAmount ?? 0) - (b?.totalAmount ?? 0),
  )[0]
  return !!(cheapestInv?.promotionVJ && cheapestInv?.promotionVJDiscount)
}

export const getFlightSortTier = (state: FlightState, flightId: any): number => {
  const flight = state.flightsResult.flights[flightId]
  if (!flight) return FLIGHT_SORT_TIER.OTHER

  if (hasLuckySkyPromo(flight)) return FLIGHT_SORT_TIER.LUCKY_SKY

  const fare = state.flightsResult.fares[flight.fareDataId]
  if (fare && isGalileoSystem(fare.system)) return FLIGHT_SORT_TIER.GALILEO_1G

  const airline = getMainAirline(flight)

  // [CHỈ DEV] đẩy QH lên tier "may mắn/sky" để test.
  if (IS_DEV && airline === "QH") return FLIGHT_SORT_TIER.LUCKY_SKY

  switch (airline) {
    case "9G":
      return FLIGHT_SORT_TIER.NINE_G
    case "VN":
    case "QH":
      return FLIGHT_SORT_TIER.VN_QH
    case "VJ":
    case "VU":
      return FLIGHT_SORT_TIER.VJ_VU
    default:
      return FLIGHT_SORT_TIER.OTHER
  }
}
